import { put, all } from 'redux-saga/effects'

export function * initAdminDisplay(action) {}
export function * initBackupsWindow(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'backup',
    method: 'read',
    obj: null,
    id: null
  })
}
export function * initExtractsWindow(action) {
  yield all([
    put({
      type: 'XTRACT_API_CALL',
      resource: 'extract',
      method: 'read',
      obj: null,
      id: null
    }),
    put({
      type: 'XTRACT_API_CALL',
      resource: 'compatibility_class',
      method: 'read',
      obj: null,
      id: null
    })
  ])
}
export function * initProfileWindow(action) {
  yield all([
    put({
      type: 'XTRACT_API_CALL',
      resource: 'extract',
      method: 'read',
      obj: null,
      id: null
    })
  ])
}

export function * initInventoryWindow(action) {}

export function * initPatientFlagsWindow(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'code',
    method: 'read',
    obj: null,
    id: null
  })
}

export function * initUserManagementWindow(action) {
  yield all([
    put({
      type: 'XTRACT_API_CALL',
      resource: 'user',
      method: 'read',
      id: null
    }),
    put({
      type: 'XTRACT_API_CALL',
      resource: 'user_group',
      method: 'read',
      obj: null,
      id: null
    })
  ])
  // this comes after all() because those need to complete before this happens so this will overwrite
  // the "me" user in appConfig and have full two factor, etc details that aren't available on user models.
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'me',
    method: 'read',
    obj: null,
    id: null
  })
}

export function * initTreatmentPlanContainer(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'treatment_plan',
    method: 'read',
    obj: null,
    id: null
  })
}

export function * initAccountManagementWindow(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'account',
    method: 'read',
    obj: null,
    id: null
  })
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'account/status',
    method: 'read',
    obj: null,
    id: null
  })
}

export function * initQuestionWindow(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'question',
    method: 'read',
    obj: null,
    id: null
  })
}

export function * initQuestionnairesWindow(action) {
  yield all([
    put({
      type: 'XTRACT_API_CALL',
      resource: 'questionnaire',
      method: 'read',
      obj: null,
      id: null
    }),
    put({
      type: 'XTRACT_API_CALL',
      resource: 'question',
      method: 'read',
      obj: null,
      id: null
    })
  ])
}

export function * initMessagingWindow(action) {
  yield put({
    type: 'XTRACT_API_CALL',
    resource: 'message',
    method: 'read',
    obj: {},
    id: null
  })
}

export function * initProviderWindow(action) {
}

export function * initClickLogWindow(action) {}
